<template>
  <div ref="component" class="timeline row">
    <div class="col-4 col-md-5">
      <div ref="anchored" class="anchored decades">
        <div class="decade-item decade-item-desktop" :class="{ 'active': activeIndex === index }" @click="selectDecade(decade)" v-for="(decade, index) in decades" v-bind:key="decade.title">
          {{decade.label}}
        </div>
      </div>
    </div>
    <div ref="timeline" class="timeline-container col-7">
    <div class="row timeline-item" v-for="year in years" :id="`year-${year.year}`" :ref="`year-${year.year}`" v-bind:key="year.year">
      <div class="col-12 timeline-year title timeline-node">
        {{year.year}}
      </div>
      <div class="col-12 timeline-event timeline-node" v-for="event in year.events" v-bind:key="event.description">
        <div class="description"> 
        {{event.description}}
        </div>
        <div class="image" v-show="event.image" :style="`background-image: url('${event.image}')`">
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import Stickyfill from 'stickyfilljs'


export default {
  name: 'timeline',
  props: {
    decades: {
      type: Array
    }
  },
  data() {
    return {
      width: 0,
      scrollOptions: {
        container: this.$el,
        easing: 'ease-in',
        offset: -60,
        force: true,
        cancelable: true,
        x: false,
        y: true
      },
      activeIndex: 0,
      years: []
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 766
    }
  },
  mounted() {
    // missing forEach on NodeList for IE11
    if (window.NodeList && !NodeList.prototype.forEach) {
      NodeList.prototype.forEach = Array.prototype.forEach
    }

    this.decades.forEach(decade => {
      decade.years.forEach(year => {
        this.years.push(year)
      })
    })

    window.addEventListener('scroll', this.onScroll)
    window.addEventListener('resize', this.onResize)
    this.onResize()
    this.onScroll()
    Stickyfill.add(this.$refs.anchored)
  },
  methods: {
    isActiveRange() {
      this.years.forEach(year => {
        const ref = `year-${year.year}`
        if (year && year.year && this.$refs[ref]) {
          const yearTop = this.$refs[ref][0].getBoundingClientRect().top
          if (yearTop >= 20 && yearTop <= 200) {
            for (let index = 0; index < this.decades.length; index++) {
              const r = this.decades[index]
              if (year.year >= r.start && year.year <= r.end) {
                this.activeIndex = index
              }
            }
          }
        }
      })
    },
    selectDecade(r) {
      this.$scrollTo(`#year-${this.years.filter(event => event.year >= r.start && event.year <= r.end)[0].year}`, 500, this.scrollOptions)
    },
    onScroll() {
      this.isActiveRange()
      this.$refs.timeline.childNodes.forEach(item => {
        item.childNodes.forEach(el => {
          if (el.nodeType === 1) {
            const opacity = this.calcOpacity(el.getBoundingClientRect())
            const margin = this.calcMargin(el.getBoundingClientRect())
            el.style.opacity = opacity
            el.style.transform = `translateY(${margin}px)`
          }
        })
      })
    },
    onResize() {
      this.width = window.innerWidth
    },
    calcOpacity(clientRect) {
      const screenHeight = window.innerHeight || document.documentElement.clientHeight
      const isBellowTheFold = clientRect.top > screenHeight - 200
      if (isBellowTheFold) {
        return 0.3
      }
      return 1
    },
    calcMargin(clientRect) {
      const screenHeight = window.innerHeight || document.documentElement.clientHeight
      const isBellowTheFold = clientRect.top > screenHeight
      if (isBellowTheFold) {
        return 300
      }
      return 0
    }
  }
}
</script>
